import React, { useMemo, useState } from 'react';
import './CollectionList.css';

const DEFAULT_LABELS = {
  loading: 'Koleksiyonlar yükleniyor...',
  emptyTitle: 'Koleksiyon bulunamadı',
  emptyHint: 'Arama kriterlerinize uygun elle oluşturulmuş koleksiyon yok.',
  columnTitle: 'Koleksiyon',
  emptyIcon: '📁',
  rowIcon: '📁'
};

const CollectionList = ({
  collections,
  onOpenCollection,
  loading = false,
  labels: labelsProp
}) => {
  const labels = { ...DEFAULT_LABELS, ...labelsProp };
  const [sort, setSort] = useState({ field: 'title', direction: 'asc' });

  const handleSort = (field) => {
    setSort((prev) => {
      if (prev.field === field) {
        return { field, direction: prev.direction === 'asc' ? 'desc' : 'asc' };
      }
      return { field, direction: 'asc' };
    });
  };

  const sortedCollections = useMemo(() => {
    const sorted = [...collections].sort((a, b) => {
      if (sort.field === 'productsCount') {
        return (a.productsCount ?? 0) - (b.productsCount ?? 0);
      }
      return (a.title || '').localeCompare(b.title || '', 'tr');
    });
    return sort.direction === 'desc' ? sorted.reverse() : sorted;
  }, [collections, sort]);

  const SortIcon = ({ field }) => {
    const isActive = sort.field === field;
    if (!isActive) {
      return <span className="sort-icon sort-icon-inactive">⇅</span>;
    }
    return (
      <span className="sort-icon sort-icon-active">
        {sort.direction === 'asc' ? '▲' : '▼'}
      </span>
    );
  };

  if (loading) {
    return (
      <div className="collection-list-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
        <p>{labels.loading}</p>
      </div>
    );
  }

  if (collections.length === 0) {
    return (
      <div className="collection-list-empty">
        <div className="empty-icon">{labels.emptyIcon}</div>
        <h3>{labels.emptyTitle}</h3>
        <p>{labels.emptyHint}</p>
      </div>
    );
  }

  return (
    <div className="collection-list-container">
      <div className="collection-table-wrapper">
        <table className="collection-table">
          <thead>
            <tr>
              <th
                className="sortable-column collection-col-title"
                onClick={() => handleSort('title')}
              >
                {labels.columnTitle} <SortIcon field="title" />
              </th>
              <th
                className="sortable-column collection-col-count"
                onClick={() => handleSort('productsCount')}
              >
                Ürün <SortIcon field="productsCount" />
              </th>
              <th className="collection-col-action">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {sortedCollections.map((collection) => (
              <tr
                key={collection.id ?? collection.name}
                className="collection-row"
                onClick={() => onOpenCollection(collection)}
              >
                <td className="collection-title-cell">
                  {collection.image ? (
                    <img
                      src={collection.image}
                      alt=""
                      className="collection-thumb"
                    />
                  ) : (
                    <span className="collection-thumb collection-thumb-placeholder" aria-hidden>
                      {labels.rowIcon}
                    </span>
                  )}
                  <span className="collection-title-text">{collection.title}</span>
                </td>
                <td className="collection-count-cell">
                  {collection.productsCount ?? '—'}
                </td>
                <td className="collection-action-cell">
                  <button
                    type="button"
                    className="collection-open-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      onOpenCollection(collection);
                    }}
                  >
                    Ürünleri gör
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CollectionList;
